import classNames from "classnames";
import classes from "./NavItem.module.css";

const NavItem = (props) => {
  const { className, children } = props;
  return (
    <div className={classNames(classes["nav-item"], className)}>{children}</div>
  );
};

export default NavItem;
